/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import SendApplication from "./SendApplication";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import JobPageMeta from "../../../containers/Pages/Generic/JobsPage/JobPageMeta";
import { gaSet } from "../../../services/cookieService";
import Typography from "@mui/material/Typography";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import cvImage from "../../../assets/img/jobs/cv.svg";
import { Box } from "@mui/material";
import AreYouInterestedSection from "./AreYouInterestedSection";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";

const ServiceRAFA = () => {
  const title = "Jobs - Rechtsanwaltsfachangestellte Teamleitung Vollzeit | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <JobPageMeta />
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Rechtsanwaltsfachangestellte Teamleitung Vollzeit (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography variant={"h4"} textAlign={"center"}>
          Du bist Rechtsanwaltsfachangestellte (m/w/d) mit Führungserfahrung? Warum eine Legal-Tech-Kanzlei dein nächster Karriereschritt sein sollte!
        </Typography>
        <Typography paragraph>
          Du bist es leid, vom obligatorischen Obstkorb und halbjährlich stattfindenden Kanzleifeiern für einen Job “überzeugt” zu werden? Du willst gerne
          nachmittags deinem Hobby nachgehen oder dein Kind von der Schule oder KiTa abholen, anstatt jeden Tag von 9 Uhr bis 18 Uhr in einem kahlen Büro zu
          sitzen? Du hast bereits Führungserfahrung als Teamleitung oder Büroleitung und möchtest ein motiviertes Team leiten?
        </Typography>
        <Typography paragraph>
          Wir bieten dir eine aufregende Arbeitsumgebung für Rechtsanwaltsfachangestellte. Im Gegensatz zu traditionellen Kanzleien setzen wir als
          Legal-Tech-Kanzlei auf innovative Technologien, die die Effizienz und Effektivität von Rechtsdienstleistungen verbessern. Als Teil des Teams kannst du
          unsere eigenen Technologien nutzen und an der Entwicklung mitarbeiten oder dich einfach auf deine Fähigkeiten als Rechtsanwaltsfachangestellte
          konzentrieren, ohne zeitraubende und mühsame Aufgaben erledigen zu müssen. Du hast Ideen zur Verbesserung der Abläufe deines Teams? Dann können wir
          jederzeit auch unsere Software nach deinen Wünschen anpassen, damit sie dich in deiner Führungsposition unterstützt.
        </Typography>
        <Typography paragraph>
          Lerne Legalbird kennen und sei dabei, wenn wir nicht nur den Rechtsmarkt, sondern auch die Arbeitsbedingungen für jeden in unserem Team
          revolutionieren!
        </Typography>
        <Box>
          <TextContainer sx={jobStyles.container}>
            <Typography variant={"h4"}>Was Deine Aufgaben sein werden</Typography>
            <MuiListNativeStyled
              sx={jobStyles.list}
              listItems={[
                "Du bist der Experte in der professionellen und persönlichen Beratung für unser digitales Rechtsprodukt",
                "Kontinuierliche Weiterentwicklung und Optimierung von Prozessen, Arbeitsabläufen und Qualitätsstandards mit Unterstützung deiner direkten Kollegen und unserer Fachanwälte",
                "Aufbau und Recruiting Deines Teams",
                "Fachliche und disziplinarische Führungsverantwortung: Förderung, Motivation und Qualifizierung von Teammitgliedern durch Coachings und Feedbackgespräche",
              ]}
            />
            <Typography variant={"h4"}>Was Du dazu brauchst</Typography>
            <MuiListNativeStyled
              sx={jobStyles.list}
              listItems={[
                "Du hast ausgezeichnete Kommunikationsfähigkeiten und eine kundenorientierte, professionelle Ausdrucksweise",
                "Du hast mehrjährige Erfahrung im Rechtsbereich und bestenfalls Führungserfahrung mit dem Talent zur Motivation von Mitarbeitern ",
                "Du begeisterst Dich für den Rechtsbereich und hast bestenfalls eine Ausbildung zur Rechtsanwaltsfachangestellten / Notariatsfachangestellten",
                "Du bietest jeder Mandantschaft eine kompetente und persönliche Betreuung mit individuellen Lösungen",
                "Du hast Spaß daran, komplexe Sachverhalte zu verstehen und sie präzise und verständlich darzustellen",
              ]}
            />
            <Typography variant={"h4"}>Was wir Dir bieten und was uns auszeichnet</Typography>
            <MuiListNativeStyled
              sx={jobStyles.list}
              listItems={[
                "Eine unternehmerische und anspruchsvolle Arbeit in einem hochmotivierten Team, in dem Du Deine Karriere auf das nächste Level bringen kannst – persönliche und berufliche Weiterentwicklungsmöglichkeiten inklusive",
                "Die Chance, in einem stark wachsenden Unternehmen dabei zu sein und Verantwortung zu übernehmen",
                "Wir entscheiden und arbeiten mit vollem Kundenfokus, fakten- und ergebnisorientiert und umsetzungsstark, um unseren Kunden das bestmögliche Erlebnis zu bieten",
                "Eine tolle Arbeitsatmosphäre in modernem Büro in den Kranhäusern mit einem phantastischen Rheinblick  und sehr guter Erreichbarkeit mit ÖPNV (Deutschlandticket inklusive)",
              ]}
            />
          </TextContainer>
        </Box>

        <AreYouInterestedSection jobTitle={"Rechtsanwaltsfachangestellte:r"} />
      </TextContainer>
      <SendApplication to={"RA Frank Riedel und RAin Anna Wagner"} />
    </Layout>
  );
};

export default ServiceRAFA;
